import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";

export function BlacklistPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv
    ? "Casinon under granskning — vår watchlist"
    : "Casinos under review — our watchlist";
  const desc = isSv
    ? "Läs licensvillkor, bonusvillkor och uttagsregler innan du väljer casino."
    : "Read licence terms, bonus terms and withdrawal rules before choosing a casino.";

  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <InternalLinks context="responsible" />
    </div>
  );
}
